import { reactive } from 'vue';

const feedbackState = reactive({
  toasts: [],
  confirm: null
});

let toastSeed = 1;

function pushToast(type, message, duration) {
  const id = toastSeed++;
  feedbackState.toasts.push({
    id,
    type,
    message
  });
  window.setTimeout(() => {
    dismissToast(id);
  }, duration || 2600);
}

export function dismissToast(id) {
  feedbackState.toasts = feedbackState.toasts.filter((item) => item.id !== id);
}

export function notifySuccess(message) {
  pushToast('success', message);
}

export function notifyError(message) {
  pushToast('error', message, 3600);
}

export function notifyInfo(message) {
  pushToast('info', message);
}

export function confirmAction(options) {
  return new Promise((resolve) => {
    feedbackState.confirm = {
      title: options.title || '确认操作',
      message: options.message || '',
      confirmText: options.confirmText || '确认',
      cancelText: options.cancelText || '取消',
      tone: options.tone || 'primary',
      resolve
    };
  });
}

export function closeConfirm(result) {
  if (!feedbackState.confirm) {
    return;
  }
  const current = feedbackState.confirm;
  feedbackState.confirm = null;
  current.resolve(Boolean(result));
}

export default feedbackState;
